import app from "../data/base";

async function loadRuoli() {
  try{
    const response = await app.methods.callserver('api/admin/role','GET',null,null,true);
    return await response.json();
  } catch (e) {
    console.error(e);
    throw e
  }
}

export const ruoli = {
  methods: {
    loadRuoli
  }
}
